module.exports = {
  TODO: 'todo',
  OPEN: 'open',
  PAUSED: 'paused',
  WAITING: 'waiting',
  CLOSED: 'closed',
  RATED: 'rated',
  VOID: 'void',
};
